import React, { useEffect } from 'react';
import { fromUnixTime, format } from 'date-fns';
import PropTypes from 'prop-types';

// Components
import FavoriteIcon from '@icons/FavoriteIcon';
import ShareIcon from '@icons/ShareIcon';
import { BodySmall, H3, LabelLarge, ChipButtonLightGray } from '@styled';
import SessionsSharePopover from '../_molecules/SessionsSharePopover';

// Helpers
import { getTimeRangeText } from '@general/dates';

const SessionsModal = ({
   id,
   title,
   sessionType,
   sessionTracks = [],
   sessionStartUnix,
   sessionEndUnix,
   sessionRoom,
   description,
   event,
   isFavorite,
   isLoadingFavorite,
   toggleFavorite,
}) => {
    if (!sessionStartUnix) return null;

    const sessionDate = fromUnixTime(sessionStartUnix);
    const sessionEndDate = fromUnixTime(sessionEndUnix);

    const handleFavoriteClick = (e) => {
        if (toggleFavorite) {
            toggleFavorite(e);
        }
    };

    return (
        <div className="sessions-modal-container">
            <div className="flex-grow-1">
                {sessionType && sessionType.toUpperCase() !== 'SELECT SESSION TYPE' && (
                    <LabelLarge className="text-primary">{sessionType}</LabelLarge>
                )}

                <H3 className="mt-2 mb-4">{title}</H3>

                {sessionTracks.length > 0 && (
                    <div className="modal-chip-container">
                        {sessionTracks.map((track, index) => (
                            <ChipButtonLightGray key={`modal-track-${index}`} as="div" className="modal-track-chip">
                                {track}
                            </ChipButtonLightGray>
                        ))}
                    </div>
                )}

                <div className="mb-4">
                    <BodySmall>{format(sessionDate, 'EEEE, MMMM d, yyyy')}</BodySmall>
                    <BodySmall>{getTimeRangeText(sessionDate, sessionEndDate)}</BodySmall>
                    <BodySmall>&nbsp;</BodySmall>
                    {sessionRoom && <BodySmall>{sessionRoom}</BodySmall>}
                </div>

                {description && (
                    <div
                        className="modal-description-wrapper"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                )}
            </div>

            <div className="modal-footer-custom d-flex justify-content-end align-items-center gap-3">
                <SessionsSharePopover title={title} url={event?.url} />

                <div className="icon-click-wrapper" onClick={toggleFavorite}>
                    <FavoriteIcon
                        id={id}
                        type="session"
                        isLoggedIn={true}
                        isFavorite={isFavorite}
                        isLoading={isLoadingFavorite}
                        onClick={() => {}}
                    />
                </div>
            </div>
        </div>
    );
};

SessionsModal.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    sessionType: PropTypes.string,
    sessionTracks: PropTypes.arrayOf(PropTypes.string),
    sessionStartUnix: PropTypes.number,
    sessionEndUnix: PropTypes.number,
    sessionRoom: PropTypes.string,
    description: PropTypes.string,
    event: PropTypes.object,
    isFavorite: PropTypes.bool,
    isLoadingFavorite: PropTypes.bool,
    toggleFavorite: PropTypes.func,
};

export default SessionsModal;